import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch } from './store'
import { getQueryStringValue } from './util'

export const useIsGeorgetownSite = (): boolean => {
  return !!getQueryStringValue("georgetown")
}

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector